<div
  class="info"
  [ngClass]="{
    success: variant === 'success',
    error: variant === 'error',
    snackbar: isSnackbarMode
  }"
>
  <div class="info__main">
    <div class="info__icon-block">
      <cheelee-icon
        class="info__icon"
        *ngIf="variant !== 'error'; else errorIcon"
        [iconId]="iconId"
      />
    </div>
    <div class="info__message-block text-1">
      <span
        class="info__message"
        *ngIf="message.includes(':'); else translated"
        >{{ message | i18nextEager }}</span
      >
      <ng-template #translated>
        <span class="info__message">{{ message }}</span>
      </ng-template>
    </div>
  </div>

  <div
    class="info__action"
    *ngIf="action"
  >
    <button
      class="info__action-btn uppercase bold"
      cheeleeRipple
      (click)="action()"
    >
      {{ actionBtnText | i18nextEager }}
    </button>
  </div>
</div>

<!-- eslint-disable max-len -->
<!-- Preload Error Icon -->
<ng-template #errorIcon>
  <svg
    id="exclamation-bubble-icon"
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path
      clip-rule="evenodd"
      d="M5.80287 2.56337C3.71121 2.56337 2.00005 4.27453 2.00005 6.36619V14.2535C2.00005 16.3452 3.71121 18.0563 5.80287 18.0563H8.97326L11.6507 21.2945L11.6539 21.2977C11.6898 21.3336 11.7414 21.3676 11.7913 21.3925C11.8396 21.4167 11.8948 21.4366 11.9375 21.4366H11.94C12.0005 21.4366 12.0509 21.4366 12.1017 21.4282C12.1543 21.4194 12.2058 21.4019 12.2714 21.3691L12.2783 21.3657L12.3464 21.2978L15.0268 18.0563H18.1972C20.2889 18.0563 22 16.3452 22 14.2535V6.36619C22 4.27453 20.2889 2.56337 18.1972 2.56337H5.80287ZM2.90772 6.36619C2.90772 4.76458 4.20125 3.47104 5.80287 3.47104H18.1346C19.7362 3.47104 21.0298 4.76458 21.0298 6.36619V14.2535C21.0298 15.8565 19.7975 17.1487 18.1972 17.1487H14.817C14.6785 17.1487 14.5414 17.2167 14.4706 17.2875L12 20.2522L9.53235 17.2906L9.52933 17.2876C9.45852 17.2168 9.32161 17.1487 9.18315 17.1487H5.80287C4.20125 17.1487 2.90772 15.8551 2.90772 14.2535V6.36619Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M5.80287 2.88837C3.8907 2.88837 2.32505 4.45403 2.32505 6.36619V14.2535C2.32505 16.1657 3.8907 17.7313 5.80287 17.7313H9.12624L11.8882 21.0717C11.8913 21.0742 11.8953 21.0772 11.9004 21.0807C11.9113 21.0881 11.9239 21.0955 11.9366 21.1018C11.9426 21.1049 11.9484 21.1075 11.9535 21.1096L11.9584 21.1116C12.0104 21.1114 12.0306 21.1105 12.0482 21.1076C12.057 21.1061 12.0689 21.1035 12.0892 21.0953L12.1059 21.0786L14.8739 17.7313H18.1972C20.1094 17.7313 21.675 16.1657 21.675 14.2535V6.36619C21.675 4.45403 20.1094 2.88837 18.1972 2.88837H5.80287ZM1.67505 6.36619C1.67505 4.09504 3.53172 2.23837 5.80287 2.23837H18.1972C20.4684 2.23837 22.3251 4.09504 22.3251 6.36619V14.2535C22.3251 16.5247 20.4684 18.3813 18.1972 18.3813H15.1798L12.5868 21.517L12.4705 21.6329L12.4168 21.6597C12.3301 21.7031 12.2474 21.7334 12.1551 21.7487C12.0772 21.7617 12.0029 21.7617 11.9484 21.7616L11.9375 21.7616C11.816 21.7616 11.7044 21.7125 11.6459 21.6832C11.5759 21.6482 11.4922 21.5956 11.4241 21.5275L11.4101 21.5135L8.82027 18.3813H5.80287C3.53172 18.3813 1.67505 16.5247 1.67505 14.2535V6.36619ZM2.58272 6.36619C2.58272 4.58508 4.02176 3.14604 5.80287 3.14604H18.1346C19.9157 3.14604 21.3548 4.58508 21.3548 6.36619V14.2535C21.3548 16.0268 19.9861 17.4737 18.1972 17.4737H14.817C14.7993 17.4737 14.7739 17.4785 14.7463 17.4903C14.7331 17.4959 14.7218 17.5022 14.713 17.5079C14.7101 17.5098 14.7077 17.5116 14.7058 17.513L12 20.7598L9.29551 17.5141C9.29345 17.5125 9.29057 17.5104 9.28678 17.5079C9.27797 17.5021 9.26666 17.4959 9.25357 17.4903C9.22593 17.4785 9.20068 17.4737 9.18315 17.4737H5.80287C4.02176 17.4737 2.58272 16.0346 2.58272 14.2535V6.36619ZM5.80287 3.79604C4.38074 3.79604 3.23272 4.94407 3.23272 6.36619V14.2535C3.23272 15.6756 4.38074 16.8237 5.80287 16.8237H9.18315C9.41347 16.8237 9.63151 16.9302 9.75914 17.0578L9.77262 17.0713L12.0001 19.7445L14.2304 17.0681L14.2408 17.0577C14.3687 16.9298 14.5869 16.8237 14.817 16.8237H18.1972C19.609 16.8237 20.7048 15.6861 20.7048 14.2535V6.36619C20.7048 4.94407 19.5568 3.79604 18.1346 3.79604H5.80287Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      d="M11.2 6.88449C11.2 6.44266 11.5582 6.08449 12 6.08449C12.4418 6.08449 12.8 6.44266 12.8 6.88449V11.2845C12.8 11.7263 12.4418 12.0845 12 12.0845C11.5582 12.0845 11.2 11.7263 11.2 11.2845V6.88449Z"
      fill="currentColor"
    />
    <path
      d="M12.8 13.9505C12.8 14.3924 12.4418 14.7505 12 14.7505C11.5582 14.7505 11.2 14.3924 11.2 13.9505C11.2 13.5087 11.5582 13.1505 12 13.1505C12.4418 13.1505 12.8 13.5087 12.8 13.9505Z"
      fill="currentColor"
    />
  </svg>
</ng-template>
